import { memo } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { getRoute } from 'Config';
import appendLangPrefix from 'Lib/utils/appendLangPrefix';

import { I13nAnchor } from 'Components/I13n';

import TinderLogo, { type TinderLogoType } from 'Assets/reactSvgs/TinderLogo';
import { commonLinkStyle } from 'Styles/sharedStyle';

type Props = {
  className?: string;
  title?: string;
  type?: TinderLogoType;
  tabIndex?: number;
};

const TinderLogoLink = (props: Props) => {
  const { formatMessage, locale } = useIntl();
  const {
    className,
    title = formatMessage({ id: 'tinderHome' }),
    type = 'default',
    tabIndex = 0,
  } = props;

  const href = appendLangPrefix(getRoute('login', { pathConfig: { withPrefix: false } }), locale);

  return (
    <I13nAnchor
      className={classNames('C(inh)', commonLinkStyle)}
      href={href}
      i13nModel={{ label: 'Logo', message: 'Tinder' }}
      tabIndex={tabIndex}
    >
      <TinderLogo className={className} type={type} aria-hidden />
      <span className="Hidden">{title}</span>
    </I13nAnchor>
  );
};

export default memo(TinderLogoLink);
